import { useTranslation } from 'react-i18next';
import MainNavigation from './MainNavigation';
import {
  useMenuLinks,
  useMobileMenuNavigation,
  useQuickNavigationLinks,
} from './NavigationProvider';
import SideNavigation from './SideNavigation';
import { Overlay, Wrapper } from './wrapper';

interface NavigationV2Props {
  unknownBranch?: boolean;
  error?: boolean;
}

const NavigationV2 = ({ unknownBranch, error }: NavigationV2Props) => {
  const { t } = useTranslation(['mainNavigation']);
  const { mobileMenu, onToggleMobileMenu } = useMobileMenuNavigation();
  const quickNavigationLinks = useQuickNavigationLinks();
  const menuLinks = useMenuLinks();
  return (
    <>
      {mobileMenu && (
        <Overlay
          onClick={onToggleMobileMenu}
          title={t('closeMainNavigation', { ns: 'mainNavigation' })}
        />
      )}
      <Wrapper
        aria-label={t('mainNavigation', { ns: 'mainNavigation' })}
        $isOpenMobile={mobileMenu}
        className={mobileMenu ? 'mobile-nav-open' : undefined}
      >
        <SideNavigation
          unknownBranch={unknownBranch}
          navigationLinks={quickNavigationLinks}
          error={error}
        />
        {!error && <MainNavigation pages={menuLinks} />}
      </Wrapper>
    </>
  );
};

export default NavigationV2;
